import { render } from "./proEmpty.vue?vue&type=template&id=8a853ca6"
import script from "./proEmpty.vue?vue&type=script&lang=js"
export * from "./proEmpty.vue?vue&type=script&lang=js"

import "./proEmpty.vue?vue&type=style&index=0&id=8a853ca6&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__